/* istanbul ignore file */
import React from 'react';

import { ROUTES } from '../../constants';
import App from './components/App';

const config = {
  name: 'Featured',

  apiUrl: process.env.API_URL,
  apiKey: process.env.API_KEY,
  staticDataEndpoint: process.env.STATIC_DATA_ENDPOINT,
  excShellUrl: process.env.EXC_SHELL_URL,
  installEndpoint: process.env.INSTALLATION_SERVICE_URL,
  rnrApiKey: process.env.REACT_APP_CLIENT_ID,
  appRegistryEndpoint: process.env.APP_REGISTRY_URL,
  basepath: ROUTES.FEATURED,
  ROUTES,
};

const FeaturedPage = () => <App key="featured-app" config={config} />;

export default FeaturedPage;
